/**
 * Internal Convelio supplier accounts (Le Bourget & Heathrow hubs).
 * Some information is only surfaced to these internal teams.
 */
export const CONVELIO_INTERNAL_SUPPLIER_NAMES = [
  'Convelio Heathrow',
  'Convelio Le Bourget'
];

/**
 * Returns true when the account belongs to an internal Convelio supplier team.
 */
export const isConvelioSupplier = (accountName?: string | null): boolean =>
  !!accountName && CONVELIO_INTERNAL_SUPPLIER_NAMES.includes(accountName);
